<div class="panel-container">
    <mat-icon svgIcon="flag" />
    <div class="version-title">
        {{ 'version-history.panel.folder.title' | translate }}
    </div>
    <div class="row-container">
        <div>{{ 'version-history.panel.folder.created' | translate }}</div>
        <div class="created-text">{{ vessel.createdBy }}</div>
    </div>

    <div class="row-container" *ngIf="vessel.creationDate">
        <div>{{ getCreatedDate() }}</div>
    </div>

    <div class="row-container" *ngIf="vessel.templateVersion">
        <div>{{ 'version-history.panel.folder.template' | translate }}</div>
        <div class="template-version">
            {{ templateText }}
        </div>
    </div>
</div>
